import React from 'react'
import { useRouter } from 'next/router'
import styled from '@emotion/styled'
import Link from 'next/link'

import { COLORS, colors } from 'parameters/index'
import { Container } from '../../../shared/layout/Container'

const navItems = [
	{ name: 'Dashboard', path: '/dashboard', prefixes: ['/dashboard'] },
	{ name: 'Searches', path: '/search/history', prefixes: ['/search'] },
	{ name: 'Reading List', path: '/learn/reading-list', prefixes: ['/learn/reading-list'] },
	{ name: 'Account', path: '/account', prefixes: ['/account'] }
]

export const DashboardNav = (): JSX.Element => {
	const router = useRouter()

	return (
		<SubNavMain>
			<Line />
			<Container>
				<SubNavList>
					{navItems.map(item => (
						<Link href={item.path} key={item.path} prefetch={false} passHref legacyBehavior>
							<SubNavItem
								className={item.prefixes.some(p => router.pathname.toLowerCase().includes(p)) ? 'active' : ''}
							>
								{item.name}
							</SubNavItem>
						</Link>
					))}
				</SubNavList>
			</Container>
		</SubNavMain>
	)
}

const SubNavMain = styled.div`
	background-color: ${COLORS.SMOKE_WHITE};
	position: relative;
	padding: 0;
`

const Line = styled.div`
	position: absolute;
	width: 100%;
	height: 2px;
	background-color: #bdc4c9;
	bottom: 0;
	left: 0;
	right: 0;
`

const SubNavList = styled.div`
	list-style-type: none;
	display: flex;
	overflow: auto;
	white-space: nowrap;
	height: 40px;
	-ms-overflow-style: none; /* Internet Explorer 10+ */
	scrollbar-width: none; /* Firefox */
	::-webkit-scrollbar {
		display: none; /* Safari and Chrome */
	}
	.active {
		border-bottom: 2px solid ${colors.primaryPurple1};
		color: ${colors.primaryPurple1};
		z-index: 1;
	}
`

const SubNavItem = styled.a`
	color: ${colors.primaryDarkGrey1};
	&:hover {
		color: ${colors.secondaryPurple1};
	}
	margin-right: 24px;
	padding: 10px 0 6px 0;
	cursor: pointer;
	text-decoration: none;
`
